export const PAST_CONFIRM_TIME_MESSAGE = '현재 시간 이후로 선택해 주세요';

/*
  일정조율형 예약확정 시각이 이미 지났는지.
  확정 캘린더는 오늘부터 고를 수 있어서, 오늘 날짜의 지난 시간은 이걸로 따로 막는다.
*/
export const isPastConfirmTime = (timeStamp: number) =>
  timeStamp < Date.now();
